import React from 'react';

function ErrorDisplay({ statusCode, detail }) {
	return (
		<div className="flex items-center justify-center min-h-screen w-full" style={{ backgroundColor: 'var(--color-bg)' }}>
			<div className="flex items-center justify-center w-full max-w-4xl px-8">
				{/* Left side - Status Code */}
				<div className="flex-1 flex justify-end pr-8">
					<div className="text-right">
						<div 
							className="text-8xl font-bold tracking-tight"
							style={{ color: 'var(--color-primary)' }}
						>
							{statusCode || 'ERROR'}
						</div>
					</div>
				</div>

				{/* Vertical separator */}
				<div 
					className="h-32 w-px"
					style={{ backgroundColor: 'var(--color-border, #e5e7eb)' }}
				></div>

				{/* Right side - Error message */}
				<div className="flex-1 pl-8">
					<div className="text-left">
						<div 
							className="text-2xl"
							style={{ color: 'var(--color-muted)' }}
						>
							{detail || 'An unexpected error occurred'}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default ErrorDisplay;